export default __webpack_public_path__ + "media/images/logo_imastodon_black-f768c193d75c28f9a84d078c03661368.svg";